import React from 'react';
import { Formik } from 'formik';
import { withTranslation } from 'react-i18next';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { Alert, Input, Button } from '../Common';
import { validationSchema } from './validation';
import { post } from '../../../actions/method';
import helper from '../../../utils/helper';

const DeleteRecord = ({ t, ...props }) => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState('');
  React.useEffect(() => {
    setError('');
  }, [props.isOpen]);
  const isRequireConfirmation = helper.isRequireConfirmation();
  async function submit({ password }, resetForm) {
    if (isRequireConfirmation) {
      const params = {
        body: { password },
      };
      setLoading(true);
      setError('');
      await post('app/users/password/verify', params)
        .then((isVerified) => {
          setLoading(false);
          if (isVerified) {
            props.onConfirm();
            resetForm();
          } else {
            setError('Password is incorrect');
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });
    } else {
      props.onConfirm();
    }
  }
  return (
    <Formik
      initialValues={{ password: '' }}
      validationSchema={isRequireConfirmation ? validationSchema : null}
      onSubmit={(values, { resetForm }) => submit(values, resetForm)}
    >
      {({ values, handleChange, errors, touched, handleSubmit, resetForm }) => {
        return (
          <Modal isOpen={props.isOpen} fade={false}>
            <ModalHeader>
              <i className="md-icon" style={{ marginRight: 10 }}>
                info
              </i>
              <span style={{ verticalAlign: 'text-bottom' }}>
                {t(props.title)}
              </span>
            </ModalHeader>
            <ModalBody>
              {t(props.body)}
              {isRequireConfirmation ? (
                <Input
                  id="password"
                  label="Please enter your password"
                  type="password"
                  value={values.password}
                  onChange={handleChange('password')}
                  invalid={touched.password}
                  error={errors.password}
                />
              ) : null}
              <Alert.Error text={error} />
            </ModalBody>
            <ModalFooter>
              <Button
                color="default"
                onClick={() => {
                  resetForm({ password: '' });
                  props.onCancel();
                }}
                disabled={loading}
              >
                {t('Cancel')}
              </Button>
              <Button color="primary" onClick={handleSubmit} loading={loading}>
                {t('Confirm')}
              </Button>
            </ModalFooter>
          </Modal>
        );
      }}
    </Formik>
  );
};

export default withTranslation('app')(DeleteRecord);
